import { FaWrench } from "react-icons/fa";

import { cn } from "utils/cn";

const wrapClassName = "item flex flex-col items-center";
const messageClassName = "text-gray font-normal";

export const Maintenance = ({ maintenanceDateString }: { maintenanceDateString?: string }) => {
  return (
    <div className="m-auto flex h-[100vh] flex-col items-center justify-center gap-4">
      <FaWrench className="text-[30px] text-gray" />
      <h1 className="text-24px">ただいまメンテナンス中です</h1>
      {maintenanceDateString && (
        <div className={`${wrapClassName} font-bold`}>
          <p>メンテナンス日時</p>
          <p>{maintenanceDateString}</p>
        </div>
      )}
      <div className={wrapClassName}>
        <p className={messageClassName}>ご迷惑をおかけしますが、</p>
        {/* mobile */}
        <p className={cn(messageClassName, "block sm:hidden")}>メンテナンス終了まで</p>
        <p className={cn(messageClassName, "block sm:hidden")}>しばらくお待ちください</p>
        {/* desktop */}
        <p className={cn(messageClassName, "hidden sm:block")}>メンテナンス終了までしばらくお待ちください</p>
      </div>
    </div>
  );
};
